// ** Auth Endpoints
export default {
  // baseUrl: 'http://localhost:8001/api/', //LOCAL
  // baseUrl: 'https://semaforos.colbiz.com.br/api/', //HOMOLOGAÇÃO
  baseUrl: 'https://bi.spregula.sp.gov.br:8443/api/', //PRODUÇÃO
  // baseUrl: 'http://35.247.248.41:8001/api/', //TEMP GCP
  // baseUrl: 'https://cab9-177-22-134-28.ngrok-free.app/api/', //HOMOLOGAÇÃO (ngrok)
  loginEndpoint: '/login',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/jwt/refresh-token',
  logoutEndpoint: '/jwt/logout',

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: 'Bearer',

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: 'accessToken',
  storageRefreshTokenKeyName: 'refreshToken'
}
